const SubOrderValidation = (
  values,
  selectedInputRows,
  selectedOutputRows,
  subOrderPersonData
) => {
  let errors = {};

  if (!subOrderPersonData || !subOrderPersonData.personId) {
    errors._subOrderPerson = "Please select a person for the sub order";
  }

  if (values._cost === 0.0 || values._cost === "" || values._cost < 0) {
    errors._cost = "Order cost must be greater than 0";
  }

  // Labour and transport costs are optional (default 0), but must not be negative
  if (values._labourCost < 0) {
    errors._labourCost = "Labour cost cannot be negative";
  }

  if (values._transportCost < 0) {
    errors._transportCost = "Transport cost cannot be negative";
  }

  const inputImportRows = selectedInputRows.filter((r) => r.importId != null);
  const inputCategoryRows = selectedInputRows.filter((r) => r.importCategoryId != null);
  const outputImportRows = selectedOutputRows.filter((r) => r.importId != null);
  const outputCategoryRows = selectedOutputRows.filter((r) => r.importCategoryId != null);

  if (inputImportRows.length === 0 && inputCategoryRows.length === 0) {
    errors._inputItems = "Please select at least one input item";
  } else {
    for (let x = 0; x < inputImportRows.length; x++) {
      if (
        inputImportRows[x].qty === 0 ||
        inputImportRows[x].qty === "" ||
        inputImportRows[x].qty === "0"
      ) {
        errors._inputItems = "Input item quantities cannot be empty or zero";
        break;
      } else if (
        inputImportRows[x].itemUintsPerOrderUnit === 0 ||
        inputImportRows[x].itemUintsPerOrderUnit === "0" ||
        inputImportRows[x].itemUintsPerOrderUnit === ""
      ) {
        errors._inputItems = "Please update item units per order unit for input items";
        break;
      } else if (
        inputImportRows[x].qty < 0 ||
        inputImportRows[x].itemUintsPerOrderUnit < 0
      ) {
        errors._inputItems = "Input item quantities and units must be positive numbers";
        break;
      }
    }
  }

  if (outputImportRows.length === 0 && outputCategoryRows.length === 0) {
    errors._outputItems = "Please select at least one output item";
  } else {
    for (let x = 0; x < outputImportRows.length; x++) {
      if (
        outputImportRows[x].qty === 0 ||
        outputImportRows[x].qty === "0" ||
        outputImportRows[x].qty === ""
      ) {
        errors._outputItems = "Output item quantities cannot be empty or zero";
        break;
      } else if (
        outputImportRows[x].itemUintsPerOrderUnit === 0 ||
        outputImportRows[x].itemUintsPerOrderUnit === "0" ||
        outputImportRows[x].itemUintsPerOrderUnit === ""
      ) {
        errors._outputItems = "Please update item units per order unit for output items";
        break;
      } else if (
        outputImportRows[x].qty < 0 ||
        outputImportRows[x].itemUintsPerOrderUnit < 0
      ) {
        errors._outputItems = "Output item quantities and units must be positive numbers";
        break;
      }
    }
  }

  const inputItemIds = inputImportRows.map((row) => row.importId);
  const outputItemIds = outputImportRows.map((row) => row.importId);
  const duplicateItems = inputItemIds.filter((id) => outputItemIds.includes(id));

  if (duplicateItems.length > 0) {
    errors._duplicateItems = "Same item cannot be both input and output";
  }

  return errors;
};

export default SubOrderValidation;
